import { Component, Input, OnInit } from '@angular/core';
import { Region } from 'app/services/interfaces/region';
@Component({
  selector: 'app-region-card',
  templateUrl: './region-card.component.html',
  styleUrl: './region-card.component.scss'
})
export class RegionCardComponent implements OnInit{

navigateToRegion() {
throw new Error('Method not implemented.');
}
  @Input() region?: Region;

  ngOnInit(): void {
    
  }

}
